import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { COMMERCE_PAGE_PATH } from '../shared/constants';
import { CommerceComponent } from './commerce.component';

const routes: Routes = [
  {
    path: COMMERCE_PAGE_PATH,
    component: CommerceComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CommerceRoutingModule {}
